import { queryOptions, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAppDispatch } from "../../../redux/hooks";
import { updateAmzOnboardingStatus } from "../../../redux/reducers/amzOnboardReducer";
import { apiClient } from "../../../zodios/client";

export const AMAZON_ONBOARDING_STATUS_QUERY_KEY = ["amazon-onboarding-status"];

export const amazonOnboardingStatusOptions = queryOptions({
  queryKey: AMAZON_ONBOARDING_STATUS_QUERY_KEY,
  queryFn: async () => await apiClient.getAmazonOnboardingStatus(),
  staleTime: 5 * 60 * 1000, // Consider stale after 5 minutes
});

export const useAmazonOnboardingStatus = () => {
  const dispatch = useAppDispatch();

  const onboardingQuery = useQuery({ ...amazonOnboardingStatusOptions, refetchOnMount: true });

  useEffect(() => {
    if (onboardingQuery.data) {
      dispatch(updateAmzOnboardingStatus(onboardingQuery.data));
    }
  }, [onboardingQuery.data, dispatch]);

  return onboardingQuery;
};
